import { Howl } from 'howler';
import { unlockAudioContext } from './unlockAudioContext';

const useCreateSound = (): { playSound: (num: number) => void } => {
  const playSound = (num: number): void => {
    unlockAudioContext(); // ensure AudioContext is resumed
    const sound = new Howl({
      src: [`/assets/audio/ball-sounds/en_num_${num}.mp3`],
    });

    sound.play();
  };

  return {
    playSound,
  };
};

export default useCreateSound;
